/**
 * 第三方对接接口
 */
import api from '../api-methods'
import { ajax } from '../api-ajax'
const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const thirdParty = {
  /**
  * 超级课程表，调用原生授权页面，获取Access_token
  * client_id        gtsJRQbMnW1AU9yTh5pa
  * client_secret    wAsfXPlq3zpuJFKUAzeH
  * callback         授权成功之后的回调用页面
  */
  superFridayAuthorization: payload => {
		// return ajax('https://open.super.cn/authz/oauth/access_token', payload)
		return api.get('https://open.super.cn/authz/oauth/access_token', payload)
	},
  /**
  * 超级课程表，调用原生授权页面成功，获取jwt等用户信息
  * open_id
  * access_token
  */
  superFridayLogin: payload => {
		return api.post(`${proxyApi}/v3/auth/super_users/login_or_sign_up`, payload)
	},
}

export default thirdParty

